import { Button, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'

export interface CurrentLinkToClipboardProps {
  overrides?: string
}

export function CurrentLinkToClipboard(props: CurrentLinkToClipboardProps) {
  const { overrides } = props

  function copyHref() {
    copy(overrides ?? window.location.href)
  }

  return (
    <Tooltip placement="bottom" title="Скопировать ссылку на таблицу в буфер">
      <Button
        icon={
          <svg
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 10L10 6"
              stroke="#333333"
              strokeLinecap="round"
              strokeWidth="1.2"
            />
            <path
              d="M7.50031 4.50031C7.50031 4.50031 8.5003 3.50028 9.5003 2.5003C10.6049 1.39574 12.3957 1.39573 13.5003 2.5003C14.6049 3.60487 14.6049 5.39573 13.5003 6.5003C12.5003 7.5003 11.5003 8.50031 11.5003 8.50031M8.50031 11.5003C8.50031 11.5003 7.5003 12.5003 6.5003 13.5003C5.39573 14.6049 3.60487 14.6049 2.5003 13.5003C1.39573 12.3957 1.39574 10.6049 2.5003 9.5003C3.50028 8.50031 4.50031 7.50031 4.50031 7.50031"
              stroke="#333333"
              strokeLinecap="round"
              strokeWidth="1.2"
            />
          </svg>
        }
        style={{
          width: '32px',
          height: '32px',
          flex: '0 0 32px',
        }}
        styles={{
          icon: {
            width: '16px',
            height: '16px',
          },
        }}
        type="text"
        onClick={copyHref}
      />
    </Tooltip>
  )
}

export default CurrentLinkToClipboard
